import EnquiryForm from "../components/common/EnquiryForm";

export default function AboutUs() {
  return (
    <main className="pt-16 md:pt-20">
      <section
        className="relative w-full h-64 md:h-80"
        style={{ backgroundImage: "url('/static/images/hero-about.webp')", backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/40" />
      </section>

      <section className="w-full bg-white">
        <div className="flex flex-col md:flex-row min-h-[500px]">
          <div className="w-full md:w-1/2 min-h-[320px] md:min-h-[500px] overflow-hidden">
            <img src="/static/images/about-pic-1.webp" alt="About Artistic Spaces" className="w-full h-full object-cover" />
          </div>
          <div className="w-full md:w-1/2 flex items-center px-8 md:px-16 lg:px-24 py-12">
            <div className="max-w-sm">
              <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-5">About us</h1>
              <p className="text-gray-600 leading-relaxed text-base mb-4">
                Founded in 2010, Artistic Spaces was created to provide accessible and affordable workspaces for a wide range of creative and entrepreneurial individuals. From artists and designers to small business owners and freelancers, our spaces are designed to inspire productivity and collaboration in a sustainable way.
              </p>
              <p className="text-gray-600 leading-relaxed text-base">
                By implementing a flexible model of sectioning studios, we've been able to reduce costs for our tenants while fostering a supportive environment that encourages growth and innovation across industries.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full bg-[#f5f4f0]">
        <div className="flex flex-col md:flex-row-reverse min-h-[500px]">
          <div className="w-full md:w-1/2 min-h-[320px] md:min-h-[500px] overflow-hidden">
            <img src="/static/images/about-pic-2.webp" alt="Artistic Spaces community" className="w-full h-full object-cover" />
          </div>
          <div className="w-full md:w-1/2 flex items-center px-8 md:px-16 lg:px-24 py-12">
            <div className="max-w-sm">
              <p className="text-gray-600 leading-relaxed text-base mb-4">
                Over the years, Artistic Spaces has grown into a thriving creative community, now with over 700 spaces across 19 locations in London, with new sites launched in Hackney Central in 2024. Our tenants include creators, entrepreneurs, and professionals from a variety of fields, all seeking affordable, flexible, and inspiring places to work.
              </p>
              <p className="text-gray-600 leading-relaxed text-base">
                At Artistic Spaces, we are committed to understanding the needs of our community and providing workspaces that help individuals and businesses thrive, no matter their focus.
              </p>
            </div>
          </div>
        </div>
      </section>

      <EnquiryForm pageUri="https://artistic-spaces.co.uk/about-us" pageName="About Us" />
    </main>
  );
}